// extracted by mini-css-extract-plugin
export default {"r_l":"_69f80f8bde _510f7b4b4c","t":"_04ecb26203"};